import { render, staticRenderFns } from "./attrNameMapping.vue?vue&type=template&id=25b1b10a&scoped=true&"
import script from "./attrNameMapping.vue?vue&type=script&lang=js&"
export * from "./attrNameMapping.vue?vue&type=script&lang=js&"
import style0 from "./attrNameMapping.vue?vue&type=style&index=0&id=25b1b10a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1b10a",
  null
  
)

export default component.exports